(function () {
  function initHero(root) {
    if (root.dataset.clReady) return; root.dataset.clReady = '1';
    var slides = root.querySelectorAll('[data-cl-slide]'), bars = root.querySelectorAll('[data-cl-bar]');
    if (slides.length < 2) return;
    var i = 0, timer = null, speed = parseInt(root.dataset.autoplaySpeed || '6000', 10);
    function go(n) {
      slides[i].classList.remove('is-active'); if (bars[i]) bars[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (bars[i]) bars[i].classList.add('is-active');
      var img = slides[i].querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager';
    }
    function play() { if (root.dataset.autoplay === 'true') { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); } }
    bars.forEach(function (b, n) { b.addEventListener('click', function () { go(n); play(); }); });
    play();
  }
  function initMarquee(root) {
    var g = root.querySelector('.cl-marquee__group'); if (!g) return;
    var set = function () { root.style.setProperty('--cl-marquee-shift', g.getBoundingClientRect().width + 'px'); };
    set(); window.addEventListener('resize', set);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
  }
  function initFooter(root) {
    if (root.dataset.clReady) return; root.dataset.clReady = '1';
    root.querySelectorAll('[data-cl-footer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.closest('[data-cl-footer-col]'); var open = !col.classList.contains('is-open');
        col.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  function init() {
    document.querySelectorAll('[data-cl-hero]').forEach(initHero);
    document.querySelectorAll('[data-cl-marquee]').forEach(initMarquee);
    document.querySelectorAll('.cl-footer').forEach(initFooter);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
